<template>
  <div style="width:100%">
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" md="10" class="pr-1">
          <v-row no-gutters>
            <v-col cols="12" md="5" class="pr-1">
              <v-autocomplete v-if="asesoresFiltro.length > 0" v-model="seleccionAsesor" multiple label="ASESOR" :items="asesoresFiltro" item-text="nombre_completo" item-value="id_usuario"></v-autocomplete>
            </v-col>
            <v-col  cols="12" md="2" class="pr-1">
              <v-text-field v-if="this.seleccionAsesor.length > 0" v-model="seleccionAnio" label="AÑO" type="number" :disabled="buscaPorCodigo"></v-text-field></v-col>
            <v-col cols="12" md="5" class="pr-1">
              <v-autocomplete v-if="this.seleccionAsesor.length > 0" v-model="seleccionMes" multiple label="MES" :items="mes" item-text="descripcion" item-value="id" :disabled="buscaPorCodigo"></v-autocomplete></v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" md="5" class="pr-1">
              <v-text-field v-model="seleccionCodigo" label="CODIGO PQR" placeholder="SFC1234567890" clearable autocomplete="off" maxlength="40" hint="Busca en todo el historial: ignora año y mes" persistent-hint @keyup.enter="actualizar_pqrs"></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-switch v-if="this.seleccionAsesor.length > 0"  v-model="filtrarEstado" label="Filtrar estado"  @change="changeEstado(filtrarEstado)"></v-switch>
            </v-col>
            <v-col cols="12" md="5">
                <v-autocomplete v-if="filtrarEstado"  v-model="seleccionEstado" multiple label="ESTADO" :items="items.items_subestados" item-text="descripcion" item-value="id"></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="2">
          <v-row>
            <v-col cols="12" md="4" >
              <v-tooltip v-if="this.seleccionAsesor.length > 0 || buscaPorCodigo"  bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :loading="objs.loading" block v-bind="attrs" v-on="on" @click="actualizar_pqrs"><v-icon>mdi-cloud-search-outline</v-icon> </v-btn>
                </template>
                <span>Filtrar</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" md="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="refrescar" :loading="loadingForm" block v-bind="attrs" v-on="on"> <v-icon>mdi-refresh</v-icon> </v-btn>
                </template>
                <span>Refrescar</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" md="4">
              <v-tooltip bottom v-if="session.area[0].area_id !== 15">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn block v-bind="attrs" v-on="on" @click="nuevo_pqr"><v-icon>mdi-file-outline</v-icon> </v-btn>
                </template>
                <span>Crear PQR</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <br>
      <bandejegaListado :rules="rules" :session="session" :colores="colores" :items="items" :items_escalamientos="objGlobal.items_escalamientos" @refresh_pqrs="refrescar"></bandejegaListado>
    </v-container>
  </div>
</template>

<script>
import bandejegaListado from '@/components/bandejas/bandeja_pqrs_listadoComponent.vue'
import recBandeja from '@/js/rec_bandeja.js'
import { AREA_ASESORES } from '@/js/areas.js'
export default {
  name: 'bandeja_pqrsComponent',
  components: {
    bandejegaListado
  },
  mixins: [recBandeja],
  props: ['session', 'colores', 'rules', 'items', 'loadingForm', 'objGlobal'],
  data: () => ({
    objs: { loading: false },
    filtrarEstado: false,
    seleccionAsesor: [],
    seleccionAnio: 0,
    seleccionMes: [],
    seleccionEstado: [],
    seleccionCodigo: '',
    mes: [{ id: 1, descripcion: 'Enero' }, { id: 2, descripcion: 'Febrero' }, { id: 3, descripcion: 'Marzo' }, { id: 4, descripcion: 'Abril' }, { id: 5, descripcion: 'Mayo' }, { id: 6, descripcion: 'Junio' }, { id: 7, descripcion: 'Julio' }, { id: 8, descripcion: 'Agosto' }, { id: 9, descripcion: 'Septiembre' }, { id: 10, descripcion: 'Octubre' }, { id: 11, descripcion: 'Noviembre' }, { id: 12, descripcion: 'Diciembre' }]
  }),
  created () {
    this.fechaActual()
  },
  computed: {
    // Asesores de SERVICIO AL CLIENTE para el filtro de la bandeja.
    //
    // Antes era items_areas[10]: una posicion fija dentro de la lista de areas ordenada por
    // descripcion. Hoy el 10 cae en SERVICIO AL CLIENTE por casualidad alfabetica; renombrar
    // cualquier area reordena el arreglo y el combo pasa a listar otra area sin ningun aviso.
    //
    // Este es un filtro de BUSQUEDA, no la lista de a quien se le puede asignar: aqui van
    // TODOS los del area, incluidos los inactivos y los que no tienen usuario en el CRM
    // maestro. Si no, no habria forma de consultar desde la bandeja el historial de un
    // asesor que ya no entra al sistema (LIZET, por ejemplo, tiene 22 casos a su nombre).
    // La lista de destinos para reasignar es otra: GET asesores_activos/1.
    //
    // Lo unico que se limpia es el ruido: un mismo usuario puede tener varias filas en la
    // misma area y salia repetido. El nombre se toma del CRM maestro y, si no esta ahi, de
    // la tabla local users: asi ninguna opcion queda en blanco.
    asesoresFiltro () {
      const areas = this.items.items_areas || []
      const area = areas.find(a => a.id === AREA_ASESORES)
      if (!area || !area.asesores) { return [] }

      const vistos = []
      return area.asesores.filter(a => {
        if (vistos.indexOf(a.id_usuario) !== -1) { return false }
        vistos.push(a.id_usuario)
        return true
      }).map(a => Object.assign({}, a, { nombre_completo: this.nombreAsesor(a) }))
    },
    buscaPorCodigo () {
      return (this.seleccionCodigo || '').trim() !== ''
    }
  },
  methods: {
    // El nombre sale del CRM maestro (crm_masterclaro.usuarios). Quien no este ahi no puede
    // iniciar sesion, asi que no deberia recibir PQRS: se marca para que se note, pero se
    // deja seleccionable porque sus casos pendientes hay que poder buscarlos.
    nombreAsesor (pAsesor) {
      if (pAsesor.usuario) {
        return (pAsesor.usuario.nombre_usuario + ' ' + pAsesor.usuario.apellido_usuario).trim()
      }
      if (pAsesor.user) {
        return (pAsesor.user.nombres + ' ' + pAsesor.user.apellidos).trim() + ' (sin usuario en el CRM)'
      }
      return 'SIN NOMBRE (id ' + pAsesor.id_usuario + ')'
    },
    nuevo_pqr () {
      this.$emit('new_inbound')
    },
    refrescar () {
      this.objGlobal.isFiltro = false
      this.seleccionCodigo = ''
      this.$emit('refresh_pqrs')
    },
    fechaActual () {
      const currentTime = new Date()
      this.seleccionAnio = currentTime.getFullYear()
      this.seleccionMes.push(currentTime.getMonth() + 1)
    },
    actualizar_pqrs () {
      const codigo = (this.seleccionCodigo || '').trim()

      if (this.seleccionAsesor.length === 0 && codigo === '') { return }

      // Buscando por codigo sin elegir asesor, se busca en la bandeja propia: es lo que se
      // esta viendo. Para buscar una PQR de cualquier area esta la busqueda por ID PQR.
      const asesores = (this.seleccionAsesor.length > 0) ? this.seleccionAsesor : [this.session.id]

      this.objGlobal.isFiltro = true
      this.rec_bandeja_escalamientos_filtro(asesores, this.seleccionAnio, this.seleccionMes, this.seleccionEstado, this.filtrarEstado, codigo)
    },
    changeEstado (pEstado) {
      if (pEstado === false) {
        this.seleccionEstado = []
      }
    }
  }
}
</script>
